import type { Block } from "building-types/blocks/blockTypes";

export function blockNew({
  id,
  name,
  sortIndex,
  levelId,
  isHalfStory = false,
  suppressShutters = false,
}: Pick<Block, "id" | "name" | "sortIndex" | "levelId"> & Partial<Block>): Block {
  return {
    entityType: "BLOCK",
    id,
    name,
    sortIndex,
    levelId,
    isHalfStory,
    suppressShutters,
  };
}
